module.exports = __webpack_public_path__ + "static/STG20_Mobile_480_Module5_Drink5_Spritz-e90961ea74b3e6e9ba8b062b1febf14b.png";